import React from 'react';
import { ButtonV2, Flex } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { pxToRem } from '@withjoy/joykit/theme';

interface HotelsExploreCtaProps {
  onClickExploreAllOptions: () => void;
  onClickWhereToStay: () => void;
}

export const HotelsExploreCta = ({ onClickExploreAllOptions, onClickWhereToStay }: HotelsExploreCtaProps) => {
  const { t } = useTranslation('websiteEditor');
  const hotelsTrans = t('venueHotels');
  return (
    <Flex
      position={{ __: 'fixed', sm2: 'absolute' }}
      flexWrap={{ __: 'wrap', md: 'nowrap' }}
      left="50%"
      bottom={{ __: 10, sm2: 7 }}
      gap={5}
      paddingX={5}
      paddingY={6}
      transform="translate(-50%, 0)"
      maxWidth={'80%'}
      border={'1px solid'}
      borderColor={'rgba(255, 255, 255, 0.50)'}
      background={'rgba(255, 255, 255, 0.72)'}
      boxShadow={'0 4px 32px 0 rgba(0, 0, 0, 0.16)'}
      backdropFilter="blur(24px)"
      borderRadius={pxToRem(16)}
      zIndex={1}
    >
      <ButtonV2
        typographyVariant="button2"
        intent="neutral"
        variant="ghost"
        textAlign="center"
        shape="rounded"
        fullWidth
        onClick={onClickExploreAllOptions}
      >
        {hotelsTrans.exploreAllOptions()}
      </ButtonV2>
      <ButtonV2
        typographyVariant="button2"
        intent="newPrimary"
        textAlign="center"
        shape="rounded"
        fullWidth
        paddingX={7}
        onClick={onClickWhereToStay}
      >
        {hotelsTrans.whereToStayPage()}
      </ButtonV2>
    </Flex>
  );
};
